"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedEntries = typedEntries;
exports.typedKeys = typedKeys;
exports.typedValues = typedValues;
function typedEntries(obj) {
    return Object.entries(obj);
}
function typedKeys(obj) {
    return Object.keys(obj);
}
function typedValues(obj) {
    return Object.values(obj);
}
